//$(function () {
//    menu_trigger = $('.nav-toggle');
//    nav = $('.nav');
//    body = $('body');
//    nav_icon = $('.nav__icon');

//    menu_trigger.click(function () {
//        $(this).toggleClass('nav-toggle--active');
//        nav.toggleClass('nav--active');
//        body.toggleClass('body--overlay');

//        if ($(this).attr('aria-expanded') === 'true') {
//            $(this).attr('aria-expanded', 'false');
//        } else {
//            $(this).attr('aria-expanded', 'true');
//        }
//    });

//    nav_icon.click(function () {
//        $(this).toggleClass('nav__icon--active');
//        $(this).closest('.nav__item').find('.nav__dropdown').toggleClass('nav__dropdown--active');
//    });

//    // Close mobile nav by click outside
//    $(document).mouseup(function (e) {
//        if (!nav.is(e.target) && !menu_trigger.is(e.target) && nav.has(e.target).length === 0) {
//            menu_trigger.removeClass('nav-toggle--active');
//            nav.removeClass('nav--active');
//            body.removeClass('body--overlay');
//        }
//    });
//});
function initScroll() {
    addEventListener("scroll", (event) => { showHeader(); });
}

function showHeader() {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
    var headerSmall = document.querySelector(".header--small");

    var scrollTop = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    if (scrollTop >= 100) {
        headerSmall.classList.add("header--small--show");
    } else {
        headerSmall.classList.remove("header--small--show");
    }
}

function initNav() {

    var menuTrigger = document.getElementById("menuTrigger");
    var nav = document.getElementById("topNav");
    var body = document.body;

    if (menuTrigger && nav) {
        menuTrigger.addEventListener('click', function () {
            menuTrigger.classList.toggle('menu-trigger--active');
            nav.classList.toggle('nav--open');
            body.classList.toggle('no-scroll');
        });
    }

    document.querySelectorAll('.nav__item--parent').forEach(function (item) {
        var dropdown = item.querySelector('.nav__dropdown--simple');
        var link = item.querySelector('.nav__link');

        if (!dropdown || !link) return;

        item.classList.add('nav__item--has-dropdown');
    });

    var topHamburger = document.getElementById("topHamburger");
    var extraDropdown = document.getElementById("extraDropdown");

    if (topHamburger && extraDropdown) {
        topHamburger.addEventListener('click', function () {
            extraDropdown.classList.toggle('active');
        });
    }
}

initNav();
initScroll();